import { gql } from '@apollo/client';
import useGQLMutation from 'src/lib/graphql/hooks/useGQLMutation';
import { useHandleMutationCompleted } from '../../components/contributions/hooks/useHandleMutationCompleted';
import { EP_QUESTION_DETAILS_QUERY } from '../question/getQuestionDetails';
const CREATE_ANSWER_MUTATION = gql `
  mutation EP_CreateAnswer($questionID: String!, $data: EPAnswerInput!) {
    ep_createAnswer(questionID: $questionID, data: $data) {
      sentForReview
    }
  }
`;
export function useCreateAnswerMutation(options) {
    const handleMutationCompleted = useHandleMutationCompleted();
    return useGQLMutation(CREATE_ANSWER_MUTATION, {
        ...options,
        refetchQueries(result) {
            if (!result.data?.ep_createAnswer.sentForReview) {
                return [EP_QUESTION_DETAILS_QUERY];
            }
            return [];
        },
        onCompleted(data) {
            handleMutationCompleted(data.ep_createAnswer);
        },
    });
}
